

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class HomeCard extends Vue {
    @Prop(String) public title: string;
    @Prop(String) public backgroundImageUrl?: string;
    @Prop(Boolean) public inLoadingState: boolean;

    get backgroundImageStyle() {
        if (!this.backgroundImageUrl) return undefined;
        return `background-image:url(${this.backgroundImageUrl}); background-size: cover;`;
    }

    public open() {
        this.$emit('open');
    }
}
